<template>
  <div class="container_wrap">
    <Swipe
      :pagination="{ clickable: true }"
      :autoHeight="true"
      @slideChange="(swiper) => slideChange(swiper)"
    >
      <template #swiperSlide>
        <swiper-slide
          class="swiper-slide"
          v-for="(book, index) of bookInfos"
          :key="index"
        >
          <div class="reserv_item basic ticket-container">
            <div class="reserv_info">
              <TicketMarquee
                class="top-marquee"
                :class="{ 'marquee-bg-filled': ticketHeaderImageUrl }"
                :ticketColor="book.lineColor"
              />

              <header class="ticket-header">
                <div class="header-content">
                  <h5>{{ book?.lineTurnName || book.lineRouteName }}</h5>
                  <div class="direction line-type">
                    <span>{{ lineTypeName(book.lineTypeCode) }}</span>
                  </div>
                </div>

                <!-- 승차/하차 정보를 헤더로 이동 -->
                <div class="station-info">
                  <div class="station-group">
                    <div
                      class="station-label"
                      @click="openMapInfo(book.expectedOnStationUid)"
                    >
                      <span>승차 정류장</span>
                      <img src="@/assets/img/icon/icon-place.svg" alt="place" />
                    </div>
                    <div class="station-detail">
                      {{
                        `${book.expectedOnStationName}, ${book.departureTimeText}`
                      }}
                    </div>
                  </div>
                  <div class="station-group">
                    <div
                      class="station-label"
                      @click="openMapInfo(book.expectedOffStationUid)"
                    >
                      <span>하차 정류장</span>
                      <img src="@/assets/img/icon/icon-place.svg" alt="place" />
                    </div>
                    <div class="station-detail">
                      {{ book.expectedOffStationName }}
                    </div>
                  </div>
                </div>
                <div class="dotted-line"></div>
              </header>

              <section class="reserv_detail">
                <dl class="date">
                  <dt>예약날짜</dt>
                  <dd>
                    {{ dayjs(book.bookDate).format("YYYY.MM.DD(dd)") }}
                  </dd>
                </dl>
                <dl class="route">
                  <dt>노선</dt>
                  <dd>
                    {{ lineTypeName(book.lineTypeCode) }}
                  </dd>
                </dl>

                <dl v-if="userInfo?.clientName" class="company">
                  <dt>회사명</dt>
                  <dd>
                    {{ userInfo.clientName }}
                  </dd>
                </dl>
                <dl v-if="userInfo?.name" class="name">
                  <dt>예약자 이름</dt>
                  <dd>
                    {{ userInfo.name }}
                  </dd>
                </dl>
                <dl v-if="userInfo?.employeeNo" class="employeeNo">
                  <dt>사번</dt>
                  <dd>{{ userInfo.employeeNo }}</dd>
                </dl>
                <dl v-if="userInfo?.deptName" class="deptName">
                  <dt>부서</dt>
                  <dd>{{ userInfo.deptName }}</dd>
                </dl>
                <dl v-if="userInfo?.clientCustomId" class="CJwroldId">
                  <dt>CJ월드 ID</dt>
                  <dd>{{ userInfo.clientCustomId }}</dd>
                </dl>
                <dl v-if="userInfo?.email" class="email">
                  <dt>이메일</dt>
                  <dd>{{ userInfo.email }}</dd>
                </dl>
                <dl v-if="userInfo?.phone" class="number">
                  <dt>휴대폰번호</dt>
                  <dd>{{ userInfo.phone }}</dd>
                </dl>
                <dl v-if="userInfo?.carNo" class="park">
                  <dt>주차</dt>
                  <dd>주차 필요 / {{ userInfo.carNo }}</dd>
                </dl>
                <dl v-if="userInfo?.carNo === ''" class="park">
                  <dt>주차</dt>
                  <dd>주차 필요없음</dd>
                </dl>

                <dl class="nop">
                  <dt>탑승인원</dt>
                  <dd>
                    <span>{{ `${book.bookCount}명` }}</span>
                    <span v-if="fareTargetText(book)">
                      {{ `(${fareTargetText(book)})` }}
                    </span>
                  </dd>
                </dl>
                <dl v-if="book.bookAmount" class="charge">
                  <dt>운임</dt>
                  <dd>{{ `${book.bookAmount.toLocaleString()}원` }}</dd>
                </dl>
                <dl class="seat">
                  <dt>좌석</dt>
                  <dd v-html="seatDisplayText(book)"></dd>
                </dl>
              </section>

              <!-- 절취선 -->
              <div class="dotted-line"></div>

              <!-- 예약 취소 -->
              <div
                class="btn-wrapper cancel-btn-wrapper"
                :class="{
                  hide: cancelable === 'false' || hideCancelBtnYn(book),
                }"
              >
                <button
                  class="book-cancel_btn"
                  type="button"
                  @click="cancelBook(book)"
                >
                  예약취소
                </button>
              </div>

              <!-- 예약 취소 기한 안내 -->
              <div
                class="cancel-notice"
                :class="{
                  'padding-bottom':
                    cancelable === 'false' || hideCancelBtnYn(book),
                }"
              >
                <p v-if="preBookCancelTermDate">
                  사전 예약 취소 기한은<br />
                  {{ preBookCancelTermDate }}까지 입니다.
                </p>

                <p
                  v-if="remainBookCancelTermDate"
                  :class="{ 'margin-top': preBookCancelTermDate }"
                >
                  잔여 예약 취소 기한은<br />
                  {{ remainBookCancelTermDate }}까지 입니다.
                </p>
              </div>
            </div>

            <!-- 마크 이미지 -->
            <div v-if="ticketMarkImageUrl" class="ticket-mark-container">
              <div class="ticket-mark"></div>
            </div>

            <div class="reserv-check"></div>
            <TicketMarquee :ticketColor="book.lineColor" />
          </div>
        </swiper-slide>
      </template>
    </Swipe>
    <iframe
      id="kcpCancelFrame"
      name="kcpCancelFrame"
      style="display: none; width: 0; height: 0; border: 0; border: none"
    ></iframe>
    <form id="kcpCancelForm" name="kcpCancelForm" method="POST">
      <input type="hidden" name="bookUid" />
      <input type="hidden" name="accessToken" :value="accessToken" />
    </form>
  </div>
</template>

<script>
import {
  getCurrentInstance,
  ref,
  computed,
  onBeforeMount,
  onBeforeUnmount,
} from "vue";
import { useStore } from "vuex";
import { SwiperSlide } from "swiper/vue";
import Swipe from "@/components/Swipe.vue";
import TicketMarquee from "@/components/BookDetail/TicketMarquee.vue";
import { formatBookCancelTerm } from "@/utils/date";
import dayjs from "dayjs";
import "dayjs/locale/ko";
dayjs.locale("ko");

export default {
  name: "BoardingPassTicket",

  components: {
    Swipe,
    SwiperSlide,
    TicketMarquee,
  },

  props: {
    bookList: {
      type: Array,
    },
    cancelable: {
      type: String,
    },
    userInfo: {
      type: Object,
    },
  },

  setup(props, { emit }) {
    const { proxy } = getCurrentInstance();
    const store = useStore();
    const serviceTypeCode = computed(
      () => store.state.common.serviceInfo.serviceTypeCode
    );
    // 사전 예약 취소 기한
    const preBookCancelTermDate = computed(() => {
      const preBookInterval =
        store.state.common.serviceInfo.bookIntervals?.find(
          (bookInterval) => bookInterval.bookPointCode === "BKP-PRE"
        );
      if (!preBookInterval) {
        return;
      }
      const { bookCancelDtm } = preBookInterval;
      return formatBookCancelTerm(bookCancelDtm);
    });

    // 잔여 예약 취소 기한
    const remainBookCancelTermDate = computed(() => {
      const remainBookInterval =
        store.state.common.serviceInfo.bookIntervals?.find(
          (bookInterval) => bookInterval.bookPointCode === "BKP-POST"
        );
      if (!remainBookInterval) {
        return;
      }
      const { bookCancelDtm } = remainBookInterval;
      return formatBookCancelTerm(bookCancelDtm);
    });

    // 티켓 헤더 이미지
    const ticketHeaderImageUrl = computed(() => {
      return store.state.common.serviceInfo?.contentProps?.style?.ticket?.header
        ?.bg?.path;
    });

    // 티켓 마크 이미지
    const ticketMarkImageUrl = computed(() => {
      return store.state.common.serviceInfo?.contentProps?.style?.ticket?.mark
        ?.path;
    });

    // 다크모드 티켓 마크 이미지
    const darkModeTicketMarkImageUrl = computed(() => {
      return store.state.common.serviceInfo?.contentProps?.style?.ticket?.mark
        ?.darkModePath;
    });

    // 티켓 헤더 및 마크 이미지 설정
    const setTicketImages = () => {
      const style = document.documentElement.style;
      const ticketColor = style.getPropertyValue("--ticket-color");

      style.setProperty(
        "--ticket-header-bg",
        ticketHeaderImageUrl.value
          ? `url(${ticketHeaderImageUrl.value})`
          : ticketColor
      );
      style.setProperty(
        "--ticket-mark-bg",
        ticketMarkImageUrl.value ? `url(${ticketMarkImageUrl.value})` : "#fff"
      );
      style.setProperty(
        "--darkmode-ticket-mark-bg",
        ticketMarkImageUrl.value
          ? `url(${darkModeTicketMarkImageUrl.value})`
          : "#2D3034"
      );
    };

    const bookInfos = computed(() => {
      if (serviceTypeCode.value === "PGT-HOLIDA") {
        let bookLines = [];
        props.bookList.forEach((bookInfo) => {
          const lines = bookInfo.lines.map((line) => {
            const { bookPointCode, roundTripYn } = bookInfo;
            const computedBookAmount = line.bookDetails.reduce(
              (totalAmount, bookInfo) => totalAmount + bookInfo.bookAmount,
              0
            );
            return {
              ...line,
              bookPointCode,
              computedRoundTripYn: roundTripYn,
              bookAmount: computedBookAmount,
            };
          });
          bookLines = [...bookLines, ...lines];
        });
        return bookLines;
      } else {
        // 2025 4/21 백의종군길 티켓 데이터(회차명, 노선유형, 승/하차 정류장명) 안보이는 문제로 인한 코드 수정
        // TODO: 다음 FESTA에서 정상동작하는지 확인(bookAmount도 확인 필요)
        // return props.bookList;
        let bookLines = [];
        props.bookList.forEach((bookInfo) => {
          const lineTypeCodes = bookInfo.lines.map((line) => line.lineTypeCode);
          const computedRoundTripYn =
            lineTypeCodes.includes("LRT-FORWAR") &&
            lineTypeCodes.includes("LRT-BACKWA");
          const lines = bookInfo.lines.map((line) => {
            // const { bookPointCode, roundTripYn, bookAmount } = bookInfo;
            return { ...bookInfo, ...line, computedRoundTripYn };
          });
          bookLines = [...bookLines, ...lines];
        });
        return bookLines;
      }
    });

    // 요금 대상별로 분류하다.
    const mapFareTargets = (bookDetails) => {
      const fareTargetMap = new Map();
      bookDetails.forEach((bookDetail) => {
        const { fareTargetCode, fareTargetName } = bookDetail;

        // map에 있으면 요금 대상의 count를 +1 한다.
        if (fareTargetMap.has(fareTargetCode)) {
          const fareTargetValue = fareTargetMap.get(fareTargetCode);
          fareTargetMap.set(fareTargetCode, {
            ...fareTargetValue,
            count: fareTargetValue.count + 1,
          });
        } else {
          // map에 없으면 새로운 요금 대상을 추가한다.
          fareTargetMap.set(fareTargetCode, { fareTargetName, count: 1 });
        }
      });

      return fareTargetMap;
    };

    // 요금 대상 문구를 반환한다.
    const formattedFareTargets = (fareTargetMap) => {
      const textList = [];
      for (const [key, value] of fareTargetMap) {
        if (!key) {
          continue;
        }
        textList.push(`${value.fareTargetName} ${value.count}`);
      }
      return textList.join(",");
    };

    // 요금 대상 텍스트
    const fareTargetText = (book) => {
      const { bookDetails, bookDetailFareTargetName } = book;
      if (!bookDetails?.length) {
        return bookDetailFareTargetName ? `${bookDetailFareTargetName}` : "";
      }

      const fareTargetMap = mapFareTargets(bookDetails);
      return formattedFareTargets(fareTargetMap);
    };

    const bookIntervals = computed(() => store.getters["common/bookIntervals"]);
    const accessToken = store.state.member.accessToken;

    // lineTypes (행사장행, 귀가행) or (귀향행, 귀경행)
    store.dispatch("line/FETCH_LINE_TYPES");
    const lineTypeName = (lineTypeCode) =>
      store.state.line.lineTypes.find(
        (lineType) => lineType.lineTypeCode === lineTypeCode
      )?.lineTypeName || "";

    const lineTypeNameText = () =>
      store.state.line.lineTypes
        .map((lineType) => lineType.lineTypeName)
        ?.join(", ") ?? "";

    const seatDisplayText = (bookInfo) => {
      if (serviceTypeCode.value === "PGT-FESTA") {
        return bookInfo?.seatNo ? bookInfo.seatNo : "자유석";
      }
      return bookInfo.seatInfos?.length
        ? bookInfo.seatInfos
            .map((text, idx) => {
              return `${idx}호차 ${text.join(", ")}`;
            })
            .filter((text) => text)
            .join("<br />")
        : "자유석";
    };

    const setTicketColor = (index) => {
      // 티켓 컬러 지정
      if (!props.bookList.length) {
        return;
      }
      const ticketColor = props.bookList[index]?.lineColor;
      const style = document.documentElement.style;
      if (!ticketColor) {
        return;
      }

      style.setProperty("--ticket-color", ticketColor);
      style.setProperty("--ticket-color-10", ticketColor + "1A");

      if (!ticketHeaderImageUrl.value) {
        style.setProperty("--ticket-header-bg", ticketColor);
      }
    };

    const slideChange = (swiper) => {
      emit("update:nowPageOrder", swiper.realIndex + 1);
      setTicketColor(swiper.realIndex);
    };

    const openMapInfo = async (uid) => {
      const result = await store.dispatch("line/FETCH_STATION_POSITION", {
        stationUid: uid,
      });
      emit("openMapInfo", [result]);
    };

    const bookCanceling = ref(false);
    const cancelBook = async (book) => {
      if (bookCanceling.value) {
        return;
      }
      const popupInfo = {
        title: "예약을 취소하시겠습니까?",
        leftBtnName: "아니오",
        rightBtnName: "네, 취소할게요",
        onLeftBtn: () => {
          proxy.$root.$closePopup();
        },
        onRightBtn: async () => {
          // KCP 취소
          bookCanceling.value = true;
          book.bookAmount ? cancelKCP(book.uid) : cancelFreeBook(book.uid);
          proxy.$root.$closePopup();
        },
      };
      popupInfo.content = book.computedRoundTripYn
        ? `${lineTypeNameText()} 예약이 모두 취소됩니다.`
        : "";
      proxy.$root.$openPopup(popupInfo);
    };

    const cancelFreeBook = async (uid) => {
      bookCanceling.value = false;
      const result = await store.dispatch("book/CANCEL_FREE_BOOK", {
        bookUid: uid,
      });
      if (result) {
        proxy.$root.$showToast("예약이 취소되었습니다.");
        await store.dispatch("book/FETCH_BOOK_LIST");
      }
    };

    const cancelKCP = (uid) => {
      const serviceUid = store.getters["common/serviceUid"];
      const baseUrl = `${process.env.VUE_APP_API_URL}/aibos/client/api`;
      const contextPath = `${baseUrl}/v${process.env.VUE_APP_API_VERSION}/service/${serviceUid}/cancel-kcp`;
      document.kcpCancelForm.target = "kcpCancelFrame";
      document.kcpCancelForm.bookUid.value = uid;
      document.kcpCancelForm.action = contextPath;
      document.kcpCancelForm.submit();
    };

    window.paymentResult = async (result) => {
      bookCanceling.value = false;
      if (result.resultCode !== "0") {
        proxy.$root.$openErrorPopup({
          errorCode: result.resultCode,
          errorTime: dayjs(result.resultTs).format("YYYY-MM-DD HH:mm:ss"),
          errorMessage: result.resultMessage,
        });
        return;
      }
      proxy.$root.$showToast("예약이 취소되었습니다.");
      await store.dispatch("book/FETCH_BOOK_LIST");
      setTicketColor(0);
    };

    const now = ref(dayjs().format("YYYYMMDDHHmm"));
    const interval = ref(null);
    const getNowDateTime = () => {
      now.value = dayjs().format("YYYYMMDDHHmm");
    };
    const hideCancelBtnYn = (book) => {
      // const bookPointCode =
      // 	serviceTypeCode.value === 'PGT-HOLIDA'
      // 		? props.bookList[0].bookPointCode
      // 		: book.bookPointCode;
      interval.value = setInterval(getNowDateTime, 1000);
      const cancelDate = bookIntervals.value.find(
        (interval) => interval.bookPointCode === book.bookPointCode
      ).bookCancelDtm;
      const cancelDateFormat = dayjs(cancelDate).format("YYYYMMDDHHmm");
      return now.value >= cancelDateFormat ? true : false;
    };

    onBeforeMount(() => {
      setTicketColor(0);
      setTicketImages();
    });

    onBeforeUnmount(() => {
      clearInterval(interval.value);
    });

    return {
      accessToken,
      dayjs,
      bookInfos,
      bookCanceling,
      lineTypeName,
      slideChange,
      openMapInfo,
      cancelBook,
      hideCancelBtnYn,
      seatDisplayText,
      fareTargetText,
      preBookCancelTermDate,
      remainBookCancelTermDate,
      ticketHeaderImageUrl,
      ticketMarkImageUrl,
      // roundTripYn,
      // bookAmount
    };
  },
};
</script>

<style scoped>
/* 티켓 컨테이너 - 티켓 모양과 컷아웃 효과 */
.ticket-container {
  position: relative;
  border-radius: 10px;
}

/* 티켓 헤더 - 배경 이미지와 오버레이 */
.ticket-header {
  background: var(--ticket-header-bg);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  padding: 20px;
  color: white;
  display: block;
  height: unset;

  .dotted-line {
    position: absolute;
    bottom: 0px;
    width: calc(100% - 30px);
    left: 15px;
    margin: 0;
    border: none;
    height: 1px;
    background: repeating-linear-gradient(
      to right,
      #fff 0,
      #fff 4px,
      /* 대시 길이 */ transparent 4px,
      transparent 8px /* 간격 */
    );
  }
}

/* 헤더 콘텐츠 */
.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.header-content h5 {
  font-size: 32px;
  font-weight: normal;
  letter-spacing: -1.6px;
  line-height: 1;
  margin: 0;
}

.direction {
  background: white;
  color: var(--ticket-color, #8d002a);
  padding: 6px 10px;
  border-radius: 50px;
  font-size: 11px;
  max-width: 65px;
  height: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}

.direction span {
  white-space: nowrap;
  z-index: 1;
}

/* 승차/하차 정보 */
.station-info {
  display: flex;
  justify-content: space-between;
  gap: 20px;
}

.station-group {
  flex: 1;
}

.station-label {
  display: flex;
  align-items: center;
  font-size: 12px;
  margin-bottom: 8px;
  gap: 4px;
  cursor: pointer;
}

.place-icon {
  width: 16px;
  height: 16px;
  fill: currentColor;
}

.station-detail {
  font-size: 14px;
  line-height: 16px;
}

/* 티켓 본문 영역 */
.reserv_detail {
  padding: 20px 20px 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 10px;
  background: white;
  position: relative;
}

/* reserv_detail 상단에 cutout 배치 */
.reserv_detail::before,
.reserv_detail::after {
  content: "";
  position: absolute;
  top: -15px; /* cutout의 절반만큼 위로 */
  width: 30px;
  height: 30px;
  background: #f5f5f5;
  border-radius: 50%;
  z-index: 10; /* 높은 z-index로 모든 그림자 위에 표시 */
}

.reserv_detail::before {
  left: -15px; /* 좌측 cutout */
}

.reserv_detail::after {
  right: -15px; /* 우측 cutout */
}

.reserv_detail dt {
  font-size: 12px;
  font-weight: bold;
  color: #898989;
  margin-bottom: 8px;
}

.reserv_detail dd {
  font-size: 14px;
  color: #121212;
  line-height: 16px;
  margin-bottom: 24px;
}

/* 절취선 - Figma Line 57에 해당 */
.dotted-line {
  border: none;
  height: 1px;

  background: repeating-linear-gradient(
    to right,
    #909190 0,
    #909190 4px,
    /* 대시 길이 */ transparent 4px,
    transparent 8px /* 간격 */
  );
  margin: 0 20px;
  position: relative;
}

/* 예약 취소 기한 안내 */
.cancel-notice {
  padding: 20px 0 80px 0; /* 하단 패딩을 늘려서 마퀴와 간격 확보 */
  background: rgba(255, 255, 255, 0.7);
  margin: 0 20px 0 20px;
  border-radius: 4px;
  &.padding-bottom {
    padding-top: 32px;
    padding-bottom: 130px;
  }
}

.cancel-notice p {
  font-size: 14px;
  color: #121212;
  line-height: 16px;
  margin: 0;
  font-weight: 400;
  &.margin-top {
    margin-top: 8px;
  }
}

/* 마커 컨테이너 */
.ticket-mark-container {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  pointer-events: none;
}

/* 티켓 마커 이미지 - 그라데이션 투명도 적용 */
.ticket-mark {
  position: absolute;
  right: 0;
  bottom: 30px;
  width: 70%; /* 컨테이너 대비 65% 크기 */
  aspect-ratio: 1.028; /* 정사각형 비율 유지, 실제 이미지 비율에 따라 자동 조정됨 */
  background: var(--ticket-mark-bg);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 2;
  /* 좌상단으로 갈수록 불투명도 높이는 마스크 적용 */
  -webkit-mask: linear-gradient(
    135deg,
    rgba(0, 0, 0, 0) 25%,
    rgba(0, 0, 0, 0.6) 100%
  );
  mask: linear-gradient(135deg, rgba(0, 0, 0, 0) 25%, rgba(0, 0, 0, 0.3) 100%);
  opacity: 0.4;
}

/* 예약 취소 버튼 스타일 (주석처리된 버튼용) */
.cancel-btn-wrapper {
  position: relative;
  width: 100%;
  padding: 20px 20px 0;
  box-sizing: border-box;
  z-index: 5;
}

.cancel-btn-wrapper .book-cancel_btn {
  width: 100%;
  height: 44px;
  border-radius: 4px;
  font-size: 14px;
  border: 1px solid #e2e2e2;
  background: #fff;
  color: #a5a4a5;
}

/* 마퀴 영역 조정 */
.marquee {
  position: absolute;
  bottom: 0;
  left: 0;
  white-space: nowrap;
  overflow: hidden;
  background: var(--ticket-color-10);
  padding: 8px 0;
  width: 100%;
  border-radius: 0 0 8px 8px;
  z-index: 1;
}

.marquee span {
  font-weight: bold;
  color: var(--ticket-color);
  display: inline-block;
  padding-left: 10px;
  animation: marquee 5s linear infinite;
}
</style>
